import SmartDropdown from '../functions/smart-dropdown.js';
import FooterAccordions from '../functions/footer-accordions.js';
import productHeightAdjust from '../functions/product-height-adjust.js';

/**
 * Inicializa o sistema de acordeão do footer (mobile menu)
 * Baseado no comportamento do footer_content.tpl
 */
function init() {
    // Accordion mobile para footer
    if (window.matchMedia("(max-width: 1199px)").matches) {
        $('.footer-mobile-list .footer-title').off('click').on('click', function () {
            $(this).parent().toggleClass('active');
            $(this).parent().find('ul').slideToggle();
        });
    }
}

/**
 * Inicializa o botão "Voltar ao topo"
 */
function initScrollToTop() {
    const $goToTop = $('#go-totop');

    if ($goToTop.length === 0) return;

    // Mostrar/esconder botão baseado no scroll
    $(window).off('scroll.goToTop').on('scroll.goToTop', function () {
        if ($(this).scrollTop() > 100) {
            $goToTop.fadeIn();
        } else {
            $goToTop.fadeOut();
        }
    });

    // Evento de clique para rolar ao topo
    $goToTop.off('click.goToTop').on('click.goToTop', function (e) {
        e.preventDefault();
        document.documentElement.scrollIntoView({ behavior: 'smooth' });
        return false;
    });
}

/**
 * Reinicializa os acordeões quando a janela é redimensionada
 */
function handleResize() {
    let resizeTimer;
    $(window).off('resize.footerAccordion').on('resize.footerAccordion', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            init(); // Reinicializa os acordeões
        }, 250);
    });
}

/**
 * Inicializa Smart Dropdown (componente global)
 */
function initSmartDropdown() {
    try {
        new SmartDropdown();
        console.log('✅ Smart Dropdown inicializado');
    } catch (error) {
        console.warn('⚠️ Smart Dropdown não encontrado:', error);
    }
}

/**
 * Inicializa Footer Accordions (componente global)
 */
function initFooterAccordions() {
    try {
        new FooterAccordions();
        console.log('✅ Footer Accordions inicializado');
    } catch (error) {
        console.warn('⚠️ Footer Accordions não encontrado:', error);
    }
}

function initListOverflow() {
    $('.js-footer-list-expand').on('click', function () {
        const $toggle = $(this);
        const $list = $toggle.closest('.list');
        const isActive = $list.toggleClass('active').hasClass('active');

        $toggle.text(
            isActive
                ? $toggle.data('text-open')
                : $toggle.data('text-close')
        );
    });
}

export function initFooter() {
    try {
        init();
        initScrollToTop();
        handleResize();
        initSmartDropdown();
        initFooterAccordions();
        productHeightAdjust({from: 'footer'});
        initListOverflow();
    } catch (error) {
        console.error('Erro ao inicializar rodapé:', error);
    }
}
